import { useEffect, useCallback, useRef } from 'react'

import { useAccessToken } from '@b-stock/fe-core/bstock-next/components'

import { useUpdateOffersQueryData } from '@/buyer-portal/components/features/offerings/OfferingDetailsLayout/OfferingForm/useUpdateOffersQueryData'
import { findOffersQuery } from '@/buyer-portal/queries/findOffersQuery'

export const useRefetchOffersOnDecisionEndTime = ({
  offeringId,
  listingId,
  decisionTimeEnded,
  buyerWon,
}: {
  decisionTimeEnded: boolean
  buyerWon: boolean
  offeringId: string
  listingId: string
}) => {
  const accessToken = useAccessToken()

  const { refetch: refetchOffers } = findOffersQuery.useWithOpts(
    [
      {
        offeringId,
      },
    ],
    {
      enabled: false,
    }
  )

  const counter = useRef(0)

  const updateOffersQueryData = useUpdateOffersQueryData()

  const forceUpdateOffers = useCallback(async () => {
    // if decision time has ended and buyer has not won, and we have not already re-fetched once, then refetch offers

    if (decisionTimeEnded && !buyerWon && accessToken && counter.current < 1) {
      const offersResponse = await refetchOffers()
      updateOffersQueryData({
        accessToken,
        listingId,
        offeringId,
        offers: offersResponse.data?.offers,
      })
      counter.current += 1
    }
    // oxlint-disable-next-line react/exhaustive-deps
  }, [decisionTimeEnded, accessToken, offeringId, listingId, buyerWon])

  useEffect(() => {
    void forceUpdateOffers()
  }, [forceUpdateOffers])
}
